import React, { useState } from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import science from '../images/Science.jpg';
import commerce from '../images/commerse.jpg';
import arts from '../images/arts.jpeg';

const imageList = [science, commerce, arts];
const names = ["Science", "Commerce", "Arts"];
const messages = [
  "Focuses on physics, chemistry, math, and biology for careers in engineering, medicine, and technology.",
  "Covers accountancy, business, and economics for careers in finance, management, and entrepreneurship.",
  "Offers subjects like history, psychology, and sociology, leading to careers in humanities and social sciences.",
];
const pointsList = [
  ["Physics, Chemistry, Math, Biology", "Engineering and Medicine prep", "Research opportunities"],
  ["Accountancy, Business Studies, Economics", "Entrepreneurship and Finance Careers", "Global Business Skills"],
  ["History, Psychology, Sociology", "Creative Arts and Literature", "Social Science Research"],
];

const Cards = () => {
  const [activeCard, setActiveCard] = useState(null);

  const handleMouseEnter = (index) => setActiveCard(index);
  const handleMouseLeave = () => setActiveCard(null);

  return (
    <Grid
      container
      spacing={3}
      sx={{
        background: 'var(--background-light)',
        padding: { xs: 3, sm: 4, md: 8 },
        mb: 6
      }}
    >
      <Grid item xs={12}>
        <Typography
          variant="h3"
          align="center"
          sx={{ fontWeight: 800, color: 'var(--primary-color)', fontSize: { xs: '32px', sm: '38px', md: '44px' }, mb: 6 }}
        >
          Popular Streams
        </Typography>
      </Grid>

      {imageList.map((image, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Box
            position="relative"
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            sx={{
              perspective: '1500px',
              height: '350px',
              width: '100%',
              borderRadius: '24px',
            }}
          >
            <Card
              sx={{
                width: '100%',
                height: '100%',
                cursor: 'pointer',
                transformStyle: 'preserve-3d',
                transition: 'transform 0.6s cubic-bezier(0.4, 0.0, 0.2, 1)',
                transform: activeCard === index ? 'rotateY(180deg)' : 'rotateY(0deg)',
                position: 'relative',
                borderRadius: '24px',
                boxShadow: activeCard === index ? '0 20px 40px rgba(0,0,0,0.2)' : '0 10px 20px rgba(0,0,0,0.1)',
                border: 'none',
              }}
            >
              {/* Front of the Card */}
              <CardContent
                sx={{
                  position: 'absolute',
                  top: 0, left: 0, right: 0, bottom: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundImage: `url(${image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backfaceVisibility: 'hidden',
                  padding: 0,
                  borderRadius: '24px',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.2) 100%)',
                    borderRadius: '24px',
                  }
                }}
              >
                <Typography
                  variant="h4"
                  align="center"
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: '28px', sm: '32px', md: '36px' },
                    color: '#fff',
                    zIndex: 1,
                    textShadow: '0 4px 12px rgba(0,0,0,0.5)',
                    textTransform: 'uppercase',
                    letterSpacing: '2px'
                  }}
                >
                  {names[index]}
                </Typography>
              </CardContent>

              {/* Back of the Card */}
              <Box
                sx={{
                  position: 'absolute',
                  top: 0, left: 0, right: 0, bottom: 0,
                  backgroundColor: 'var(--primary-dark)',
                  color: '#fff',
                  padding: { xs: 3, md: 4 },
                  transform: 'rotateY(180deg)',
                  backfaceVisibility: 'hidden',
                  borderRadius: '24px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  border: '2px solid var(--secondary-color)'
                }}
              >
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, mb: 2, color: 'var(--secondary-color)', borderBottom: '2px solid rgba(255,255,255,0.2)', pb: 1 }}
                >
                  {names[index]} Stream
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: '15px',
                    textAlign: 'left',
                    mb: 3,
                    lineHeight: 1.6,
                    color: 'rgba(255,255,255,0.9)'
                  }}
                >
                  {messages[index]}
                </Typography>
                <ul style={{ paddingLeft: '20px', margin: 0 }}>
                  {pointsList[index].map((point, i) => (
                    <li key={i} style={{ marginBottom: '8px', color: 'rgba(255,255,255,0.7)' }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: '14px',
                          color: '#fff',
                        }}
                      >
                        {point}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </Box>
            </Card>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default Cards;
